import { render, staticRenderFns } from "./DictionaryWordsEdit.vue?vue&type=template&id=f6f8f2a8&scoped=true&"
import script from "./DictionaryWordsEdit.vue?vue&type=script&lang=js&"
export * from "./DictionaryWordsEdit.vue?vue&type=script&lang=js&"
import style0 from "./DictionaryWordsEdit.vue?vue&type=style&index=0&id=f6f8f2a8&lang=scss&scoped=true&"
import style1 from "./DictionaryWordsEdit.vue?vue&type=style&index=1&id=f6f8f2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f8f2a8",
  null
  
)

export default component.exports